import styled from 'styled-components'
import { palette, RingLoader } from '@centivo/react-components'

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`

export const LoadingScreen = () => {
  return (
    <Container>
      <RingLoader size="64px" color={palette.brand.orange} width={8} />
    </Container>
  )
}
